import React, {FC, ReactElement} from 'react';

import {Spinner} from 'components/spinner';

import s from './empty-table-placeholder.module.less';

interface IEmptyTablePlaceholderProps {
    isTableLoading: boolean;
    dataLength: number;
}

export const EmptyTablePlaceholder: FC<IEmptyTablePlaceholderProps> = ({
    isTableLoading,
    dataLength,
}: IEmptyTablePlaceholderProps): ReactElement => (
    <div className={s.placeholder}>
        {(() => {
            if (isTableLoading) {
                return <div><Spinner tip="Загрузка..." /></div>;
            }

            if (dataLength <= 0) {
                return 'Ничего не найдено';
            }

            return 'Произошла ошибка, не удалось сформировать таблицу';
        })()}
    </div>
);
